import { ACR_RESOURCE_TYPE, BUILTIN_ROLE_NAME } from '../pages/NRSettings/NRUsersAndAccess/rbac.constants';
import NRAdminIcon from '../NRIcons/NRAdminIcon';
import NRAssetIcon from '../NRIcons/NRAssetIcon';
import NROrganizationIcon from '../NRIcons/NROrganizationIcon';
import NRUsersIcon from '../NRIcons/NRUsersIcon';

const DEFAULT_ICON_SIZE = 24;

export function resolveAccessTagIcon(resourceType, color = 'currentColor', iconSize = DEFAULT_ICON_SIZE) {
  const iconProps = { height: iconSize, width: iconSize, color };

  switch (resourceType) {
    case ACR_RESOURCE_TYPE.ORGANIZATION:
      return <NROrganizationIcon {...iconProps} />;
    case ACR_RESOURCE_TYPE.ASSET_GROUP:
      return <NRUsersIcon {...iconProps} />;
    case ACR_RESOURCE_TYPE.ASSET:
      return <NRAssetIcon {...iconProps} />;
    default:
      return null;
  }
}

/** Maps grant tag summaries to the generic NRTagList tag shape (name, description, icon). Org-scoped owner role only. */
export function mapAccessTagsToNrTags(tagSummaries = [], iconColor, iconSize = DEFAULT_ICON_SIZE) {
  const iconProps = { height: iconSize, width: iconSize, color: iconColor };

  return tagSummaries
    .filter(
      ({ roleName, resourceType }) => (roleName || '').toLowerCase() === BUILTIN_ROLE_NAME.OWNER && resourceType === ACR_RESOURCE_TYPE.ORGANIZATION
    )
    .map(({ roleName, resourceLabel }) => ({
      name: roleName,
      value: roleName,
      description: resourceLabel || undefined,
      icon: <NRAdminIcon {...iconProps} />
    }));
}
